<h1 mat-dialog-title data-testid="confirm-dialog-title">{{ data.title | translate }}</h1>
<div mat-dialog-content data-testid="confirm-dialog-content">
  <div class="info-box">
    <p
      [innerHTML]="data.message | translate | markdown"
      class="show-breaks"
      style="white-space: pre-line"
      data-testid="confirm-dialog-message"
    ></p>
  </div>
</div>
<div
  class="p-b-2"
  fxLayoutAlign="end start"
  mat-dialog-actions
  data-testid="confirm-dialog-actions"
>
  <button (click)="noActionClicked()" mat-button data-testid="confirm-dialog-cancel-button">
    {{ 'COMMON.cancel' | translate }}
  </button>
  @if (data.altConfirmText) {
    <button [mat-dialog-close]="false" mat-button data-testid="confirm-dialog-alt-button">
      {{ data.altConfirmText | translate }}
    </button>
  }
  @if (data.confirmText) {
    <button
      [color]="data.confirmColor"
      [mat-dialog-close]="true"
      mat-flat-button
      data-testid="confirm-dialog-confirm-button"
    >
      {{ data.confirmText | translate }}
    </button>
  }
</div>
